import React from 'react';
import PropTypes from 'prop-types';

import DraggableCategoryShift from './DraggableCategoryShift';

export default function UnassignedScheduleCategory({
  shifts = [],
  category,
  onMoveRow,
  onShiftSelect,
}) {
  return (
    <div>
      <div className="schedule-category-title-container">
        <div style={{ width: 5, paddingRight: 10, height: 20 }}>
          <svg width="5" height="20" xmlns="http://www.w3.org/2000/svg">
            <rect width="5" height="100%" x="0" y="0" fill={category.color || '#FFFFFFF'} />
          </svg>
        </div>
        <div style={{ fontWeight: 650 }}>{category.name}</div>
        <div style={{ flexGrow: 1 }} />
        <div style={{ fontWeight: 650, paddingRight: 10 }}>
          {shifts.length}
        </div>
      </div>
      {!!shifts.length && (
        <div className="schedule-category-shift-container">
          {shifts
            .map((shift, index) => (
              <DraggableCategoryShift
                key={shift.id}
                shift={shift}
                index={index}
                category={category}
                onMoveRow={onMoveRow}
                isDraggable
                onShiftSelect={onShiftSelect}
              />
            ))}
        </div>
      )}
      {!shifts.length && (
        <DraggableCategoryShift
          shift={{ id: null, title: 'No shifts' }}
          onMoveRow={onMoveRow}
          category={category}
          onShiftSelect={onShiftSelect}
        />
      )}
    </div>
  );
}

UnassignedScheduleCategory.propTypes = {
  shifts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })),
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
  }).isRequired,
  onMoveRow: PropTypes.func.isRequired,
  onShiftSelect: PropTypes.func.isRequired,
};

UnassignedScheduleCategory.defaultProps = {
  shifts: [],
};
